/****************************************************
 * Module Name:  addCriteriaModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, TextField, InputLabel, Select, MenuItem, FormHelperText, Typography } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddCriteriaModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userOptions: this.props.userOptions,
            newstoneid: this.props.editOperation ? this.props.sourceData.stoneid : "",
            newcertficate: this.props.editOperation ? this.props.sourceData.certificate : "",
            newclarity: this.props.editOperation
                ? this.props.sourceData.clarity
                : "",
            newcarat: this.props.editOperation
                ? this.props.sourceData.carat
                : "",
            newcolor: this.props.editOperation
                ? this.props.sourceData.color
                : "",
            newcut: this.props.editOperation
                ? this.props.sourceData.cut
                : "",
            newflo: this.props.editOperation
                ? this.props.sourceData.flo
                : "",
            newpol: this.props.editOperation
                ? this.props.sourceData.pol
                : "",
            newshapes: this.props.editOperation
                ? this.props.sourceData.shapes
                : "",
            newstonetype: this.props.editOperation
                ? this.props.sourceData.stonetype
                : "",
            newtreatmenttype: this.props.editOperation
                ? this.props.sourceData.treatmenttype
                : "",
            newsym: this.props.editOperation
                ? this.props.sourceData.sym
                : "",
            newmystock: this.props.editOperation
                ? this.props.sourceData.mystock
                : false,
            newenable: this.props.editOperation
                ? this.props.sourceData.enable
                : true,

            newfiltertype: this.props.editOperation
                ? this.props.sourceData.filtertype
                : "",

            newuser: this.props.editOperation
                ? this.props.sourceData.user
                : "",

            newevery: this.props.editOperation
                ? this.props.sourceData.every
                : "",

            newmilky: this.props.editOperation
                ? this.props.sourceData.milky
                : "",

            newtinge: this.props.editOperation
                ? this.props.sourceData.tinge
                : "",

            showError: false,

            validateCutPresentSpinner: false,
            showValidationMessage: false,
            cutAvailable: true,

            stoneidValidationError: "",
            certificateValidationError: "",
            caratValidationError: "",
            clarityValidationError: "",
            colorValidationError: "",
            cutValidationError: "",
            floValidationError: "",
            polValidationError: "",
            shapesValidationError: "",
            stonetypeValidationError: "",
            filtertypeValidationError: "",
            userValidationError: "",
            symValidationError: "",
            daysValidationError: "",
            milkyValidationError: "",
            tingeValidationError: "",
        };
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            stoneid: this.state.newstoneid,
            certificate: this.state.newcertficate,
            carat: this.state.newcarat,
            clarity: this.state.newclarity,
            cut: this.state.newcut,
            flo: this.state.newflo,
            pol: this.state.newpol,
            shapes: this.state.newshapes,
            color: this.state.newcolor,
            stonetype: this.state.newstonetype,
            treatmenttype: this.state.newtreatmenttype,
            filtertype: this.state.newfiltertype,
            sym: this.state.newsym,
            mystock: this.state.newmystock,
            enable: this.state.newenable,
            iteration: null,
            every: this.state.newevery,
            milky: this.state.newmilky,
            tinge: this.state.newtinge,
            user: this.state.newuser,
            priority: this.state.newstonetype === "Natural Diamonds" ? 4 : 5,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else
                this.props.handleSave(data);
        }
    };

    buttonDisable = () => {
        const fields = [
            'newcertficate', 'newclarity', 'newcarat', 'newcut', 'newflo', 'newpol',
            'newshapes', 'newcolor', 'newstonetype', 'newfiltertype', 'newsym',
            'newmilky', 'newtinge', 'newstoneid', 'newuser'
        ];

        const isEmptyFieldPresent = fields.some(field => this.state[field].length === 0);

        return isEmptyFieldPresent;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add criteria validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Criteria" : "Add New Criteria"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Criteria Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Stone Id <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Stone Id"
                                                placeholder="Enter Stone Id"
                                                value={this.state.newstoneid}
                                                autoFocus
                                                onChange={(e) =>
                                                    this.setState({
                                                        newstoneid: e.target.value,
                                                        showValidationMessage: false,
                                                        stoneidValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Stone Id Cannot be Empty",
                                                    })
                                                }
                                                disabled={this.props.editOperation}
                                                helperText={this.state.stoneidValidationError}
                                                error={this.state.stoneidValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Certificate <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Certificate"
                                                placeholder="Enter Certificate"
                                                value={this.state.newcertficate}
                                                autoFocus
                                                onChange={(e) =>
                                                    this.setState({
                                                        newcertficate: e.target.value,
                                                        showValidationMessage: false,
                                                        certificateValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Certificate Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.certificateValidationError}
                                                error={this.state.certificateValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Clarity <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Clarity "
                                                placeholder="Enter Clarity"
                                                value={this.state.newclarity}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newclarity: e.target.value,
                                                        clarityValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Clarity Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.clarityValidationError}
                                                error={this.state.clarityValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Carat <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Carat "
                                                placeholder="Enter Carat"
                                                value={this.state.newcarat}
                                                autoFocus
                                                onChange={(e) =>
                                                    this.setState({
                                                        newcarat: e.target.value,
                                                        showValidationMessage: false,
                                                        caratValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Carat Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.caratValidationError}
                                                error={this.state.caratValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Color <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Color "
                                                placeholder="Enter Color"
                                                value={this.state.newcolor}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newcolor: e.target.value,
                                                        colorValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Color Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.colorValidationError}
                                                error={this.state.colorValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Cut <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Cut "
                                                placeholder="Enter Cut"
                                                value={this.state.newcut}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newcut: e.target.value,
                                                        cutValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Cut Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.cutValidationError}
                                                error={this.state.cutValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Fluorescence <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Fluorescence "
                                                placeholder="Enter Fluorescence"
                                                value={this.state.newflo}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newflo: e.target.value,
                                                        floValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Fluorescence Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.floValidationError}
                                                error={this.state.floValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Polish <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Polish "
                                                placeholder="Enter Polish"
                                                value={this.state.newpol}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newpol: e.target.value,
                                                        polValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Polish Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.polValidationError}
                                                error={this.state.polValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Shapes <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Shapes "
                                                placeholder="Enter Shapes"
                                                value={this.state.newshapes}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newshapes: e.target.value,
                                                        shapesValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Shapes Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.shapesValidationError}
                                                error={this.state.shapesValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Symmetry <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField fullWidth sx={{ mb: 2 }}
                                                size="small"
                                                margin="normal"
                                                label="Symmetry "
                                                placeholder="Enter Symmetry"
                                                value={this.state.newsym}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newsym: e.target.value,
                                                        symValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Symmetry Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.symValidationError}
                                                error={this.state.symValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Milky <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField fullWidth sx={{ mb: 2 }}
                                                size="small"
                                                margin="normal"
                                                label="Milky "
                                                placeholder="Enter Milky"
                                                value={this.state.newmilky}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newmilky: e.target.value,
                                                        milkyValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Milky Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.milkyValidationError}
                                                error={this.state.milkyValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Tinge <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField fullWidth sx={{ mb: 3 }}
                                                size="small"
                                                margin="normal"
                                                label="Tinge "
                                                placeholder="Enter Tinge"
                                                value={this.state.newtinge}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newtinge: e.target.value,
                                                        tingeValidationError: Utility.CheckIsPresent(
                                                            e.target.value
                                                        )
                                                            ? ""
                                                            : "Tinge Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.tingeValidationError}
                                                error={this.state.tingeValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Stone Type <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <FormControl fullWidth
                                                size="small" sx={{ mb: 3 }}>
                                                <InputLabel id="stone-type-label">Stone Type</InputLabel>
                                                <Select
                                                    labelId="stone-type-label"
                                                    value={this.state.newstonetype}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newstonetype: e.target.value,
                                                            stonetypeValidationError: Utility.CheckIsPresent(e.target.value)
                                                                ? ""
                                                                : "Stone Type Cannot be Empty",
                                                        })
                                                    }
                                                    label="Stone Type"
                                                    error={this.state.stonetypeValidationError.length > 0}
                                                >
                                                    <MenuItem value="Lab Grown Diamonds">Lab Grown Diamonds</MenuItem>
                                                    <MenuItem value="Natural Diamonds">Natural Diamonds</MenuItem>
                                                </Select>
                                                {this.state.stonetypeValidationError && (
                                                    <FormHelperText error>{this.state.stonetypeValidationError}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </td>
                                    </tr>
                                    {
                                        this.state.newstonetype === "Lab Grown Diamonds" ? (
                                            <tr>
                                                <td>
                                                    <Form.Label>
                                                        Treatment Type
                                                    </Form.Label>
                                                </td>
                                                <td>

                                                    <FormControl fullWidth size="small" sx={{ mb: 3 }}>
                                                        <InputLabel id="treatment-type-label">Treatment Type</InputLabel>
                                                        <Select
                                                            labelId="treatment-type-label"
                                                            value={this.state.newtreatmenttype}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    newtreatmenttype: e.target.value,
                                                                })
                                                            }}
                                                            label="Treatment Type"
                                                        >
                                                            {Object.entries(Constants.TRREATMENT_TYPE).map(([key, value]) => (
                                                                <MenuItem key={key} value={value}>
                                                                    {value}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                        ) : null
                                    }
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Filter Type <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <FormControl fullWidth
                                                size="small" sx={{ mb: 3 }}>
                                                <InputLabel id="filter-type-label">Filter Type</InputLabel>
                                                <Select
                                                    labelId="filter-type-label"
                                                    value={this.state.newfiltertype}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newfiltertype: e.target.value,
                                                            filtertypeValidationError: Utility.CheckIsPresent(e.target.value)
                                                                ? ""
                                                                : "Filter Type Cannot be Empty",
                                                        })

                                                    }
                                                    label="Filter Type"
                                                    error={this.state.filtertypeValidationError.length > 0}
                                                >
                                                    <MenuItem value="Similar or Better">Similar or Better</MenuItem>
                                                    <MenuItem value="Exact">Exact</MenuItem>
                                                </Select>
                                                {this.state.filtertypeValidationError && (
                                                    <FormHelperText error>{this.state.filtertypeValidationError}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                User <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <FormControl fullWidth
                                                size="small" sx={{ mb: 2 }}>
                                                <InputLabel id="user-label">User</InputLabel>
                                                <Select
                                                    labelId="user-label"
                                                    value={this.state.newuser}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newuser: e.target.value,
                                                            userValidationError: Utility.CheckIsPresent(e.target.value)
                                                                ? ""
                                                                : "User Cannot be Empty",
                                                        })
                                                    }
                                                    label="User"
                                                    error={this.state.userValidationError.length > 0}
                                                >
                                                    {this.state.userOptions && this.state.userOptions.length > 0 ? (
                                                        this.state.userOptions.map((option) => (
                                                            <MenuItem value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No Users Available</MenuItem>
                                                    )}
                                                </Select>
                                                {this.state.userValidationError && (
                                                    <FormHelperText error>{this.state.userValidationError}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Every (Days) <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField fullWidth
                                                size="small"
                                                sx={{ mb: 1 }}
                                                margin="normal"
                                                label="Every (days)"
                                                placeholder="Enter Every (days)"
                                                value={this.state.newevery}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newevery: e.target.value,
                                                        daysValidationError: Utility.CheckIfNumberNegative(e.target.value)
                                                            ? "Days should be positive number"
                                                            : "",
                                                    })
                                                }
                                                helperText={this.state.daysValidationError}
                                                error={this.state.daysValidationError.length > 0}
                                            />
                                            <Typography variant="body2" sx={{ mb: 2 }}>
                                                Note: 0 means once
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                My Stock <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="mystock"
                                                    name="mystock"
                                                    value={this.state.newmystock}
                                                    onChange={(e) =>
                                                        this.setState({ newmystock: e.target.value })
                                                    }
                                                >
                                                    <FormControlLabel
                                                        value="true"
                                                        control={<Radio />}
                                                        label="True"
                                                    />
                                                    <FormControlLabel
                                                        value="false"
                                                        control={<Radio />}
                                                        label="False"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Enable <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="enable"
                                                    name="enable"
                                                    value={this.state.newenable}
                                                    onChange={(e) =>
                                                        this.setState({ newenable: e.target.value })
                                                    }
                                                >
                                                    <FormControlLabel
                                                        value="true"
                                                        control={<Radio />}
                                                        label="True"
                                                    />
                                                    <FormControlLabel
                                                        value="false"
                                                        control={<Radio />}
                                                        label="False"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}